<template>
  <div class="toast">
    <Icon :name="iconName" :size="18" :color="NEUTRAL_SUPERDARK" />
    <span v-html="title"></span>
    <Button v-if="action && label" btnStyle="secondary" size="md" @click.stop="$emit(action, $event)">{{ label }}</Button>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import { getColor } from '@/lego/utils/tailwind/config';
import Button from '@/lego/components/buttons/Button.vue';
import Icon from '@/lego/components/icons/Icon.vue';

const NEUTRAL_SUPERDARK = getColor('neutral.superdark');

export default {
  components: { Button, Icon },
  props: {
    title: {
      type: String,
      required: true,
    },
    action: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      NEUTRAL_SUPERDARK,
      iconName: computed(() => {
        switch (props.type) {
          case 'success':
            return 'success';
          case 'error':
            return 'cross';
        }
      }),
    };
  },
};
</script>

<style lang="postcss">
@import 'vue-toastification/dist/index.css';
</style>

<style lang="postcss" scoped>
.toast {
  @apply flex items-center gap-x-micro text-neutral-superdark;

  & > button {
    @apply ml-xxxs border-neutral-white text-neutral-white hover:text-neutral-white hover:border-neutral-white rounded-s border-hairline !min-w-0;
  }
}
</style>
